import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

export default function BrandTrust() {
  const { ref, isVisible } = useScrollAnimation({ threshold: 0.2 });

  return (
    <section className="py-32 bg-white">
      <div 
        ref={ref}
        className={`max-w-7xl mx-auto px-6 transition-all duration-1000 ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'
        }`}
      >
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Content */}
          <div className="space-y-10 lg:order-1">
            <div className="space-y-6">
              <h3 className="text-sm tracking-[0.3em] text-stone-500 font-light" style={{ fontFamily: 'Cormorant, serif' }}>
                BRAND PHILOSOPHY
              </h3>
              
              <p className="tracking-wide text-stone-600 font-light leading-relaxed" style={{ fontFamily: 'Cormorant, serif', fontSize: '1.5rem' }}>
                Skincare research, Now for your beloved Pets
              </p>
              
              <h2 className="text-4xl md:text-5xl leading-relaxed" style={{ fontFamily: 'Noto Serif JP, serif', fontWeight: 400, color: '#705e44' }}>
                人の美容研究から<br />生まれた、<br />ペットのための<br />新しい愛情ケア
              </h2>
            </div>

            <div className="space-y-8" style={{ fontFamily: 'Noto Serif JP, serif', fontWeight: 400, color: '#705e44' }}>
              <div className="space-y-6 text-base leading-loose">
                <p className="text-lg pt-4">
                  「人生に優しく寄り添うケア」を<br />
                  <span style={{ color: '#705e44' }}>"家族であるペットにも"</span><br />
                  という想いから誕生。
                </p>
              </div>

              <div className="pt-8 space-y-4 text-sm text-stone-600 leading-relaxed">
                <p className="flex items-start gap-3">
                  <span className="text-[#C6A87B] mt-1">◆</span>
                  <span>素のままで美しい</span>
                </p>
                <p className="flex items-start gap-3">
                  <span className="text-[#C6A87B] mt-1">◆</span>
                  <span>年齢・性別・国境を超えて、すべての家族へ</span>
                </p>
                <p className="flex items-start gap-3">
                  <span className="text-[#C6A87B] mt-1">◆</span>
                  <span>愛する家族に、愛と極上のケアを</span>
                </p>
              </div>
            </div>
          </div>

          {/* Image */}
          <div className="relative lg:order-2">
            <div className="aspect-[4/5] w-full overflow-hidden">
              <img
                src="https://static.readdy.ai/image/6d9cd499b3569668e27a60fbbc899b03/378366402a392edf08fabb39bdd996dc.jpeg"
                alt="家族に寄り添うブランド"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
